/**
 * The hero call to action: three signal pixels and the words. On pointer
 * entry or keyboard-focus arrival the pixels run one sequential wave
 * (`data-wave`, see `pixel-wave.ts`); the stylesheet does the moving.
 */

import type { ReactNode } from 'react';

import type { PublicEarlyAccessCopy } from './copy.js';
import { usePixelWave } from './pixel-wave.js';

const CELLS = [0, 1, 2] as const;

export function EarlyAccessCTA({
  copy,
  onOpen,
}: {
  readonly copy: PublicEarlyAccessCopy;
  readonly onOpen: (from: HTMLElement) => void;
}): ReactNode {
  const wave = usePixelWave();
  return (
    <button
      type="button"
      className="cs-cta"
      aria-label={copy.ctaAria}
      data-wave={wave.waving ? '1' : undefined}
      onMouseEnter={wave.onMouseEnter}
      onPointerDown={wave.onPointerDown}
      onFocus={wave.onFocus}
      onClick={(event) => {
        onOpen(event.currentTarget);
      }}
    >
      <span className="cs-px3" aria-hidden="true">
        {CELLS.map((cell) => (
          <i key={cell} />
        ))}
      </span>
      <span>{copy.cta}</span>
    </button>
  );
}
